import parse from 'html-react-parser';
import { useState, useRef, useEffect } from 'react';

const OverView = ({ safariViewData }) => {
  const [expanded, setExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const contentRef = useRef(null);

  const htmlContent = safariViewData?.safari_plan ? parse(safariViewData?.safari_plan) : null;

  useEffect(() => {
    if (contentRef.current) {
      const { scrollHeight, clientHeight } = contentRef.current;
      setIsOverflowing(scrollHeight > clientHeight);
    }
  }, [safariViewData]);

  return (
    <div id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" className="tab-pane fade show active accordion-item mb-3">
      <div className="card bg-set accordion-collapse card_bodyPadding">
        <div className="card-body p-3">
          <div className="itenary-title">
            <h6 className="fs-6 fw-bold mb-4">About / Overview</h6>
          </div>
          <div
            className={`itenary_text ${!expanded ? "collapsed-text" : ""}`}
            ref={contentRef}
          >
            {htmlContent}
         
          </div>

          {/* Toggle Button only if content overflows */}
          {isOverflowing && (
            <button
              className="btn btn-link px-0 mt-2"
              style={{ textDecoration: 'none' }}
              onClick={() => setExpanded((prev) => !prev)}
            >
            <span className='show-more-btn'>{expanded ? "See Less" : "See More"}</span>  
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default OverView;
